import { render } from "./EditShopFooter.vue?vue&type=template&id=332e02df&ts=true"
import script from "./EditShopFooter.vue?vue&type=script&lang=ts"
export * from "./EditShopFooter.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__